import { DEFAULT_SCHEDULE_LIST_FILTER } from './ScheduleList.helpers';

export const SET_SCHEDULE_LIST_FILTER = 'SET_SCHEDULE_LIST_FILTER';
export const setScheduleListFilter = filter => ({ type: SET_SCHEDULE_LIST_FILTER, filter });

export const SET_SELECTED_SCHEDULE_ID = 'SET_SELECTED_SCHEDULE_ID';
export const setSelectedScheduleId = scheduleId => ({ type: SET_SELECTED_SCHEDULE_ID, scheduleId });

export const REMOVE_SELECTED_SCHEDULE_ID = 'REMOVE_SELECTED_SCHEDULE_ID';
export const removeSelectedScheduleId = () => ({ type: REMOVE_SELECTED_SCHEDULE_ID });

export const SET_LAST_ACTIVE_VENUE_ID = 'SET_LAST_ACTIVE_VENUE_ID';
export const setLastActiveVenueId = venueId => ({ type: SET_LAST_ACTIVE_VENUE_ID, venueId });

const initialState = {
  scheduleListFilter: DEFAULT_SCHEDULE_LIST_FILTER,
  selectedScheduleId: null,
  lastActiveVenueId: null,
};

export default (state = initialState, action) => {
  const { type, filter, scheduleId, venueId } = action;

  switch (type) {
    case SET_SCHEDULE_LIST_FILTER:
      return { ...state, scheduleListFilter: filter };

    case SET_SELECTED_SCHEDULE_ID:
      return { ...state, selectedScheduleId: parseInt(scheduleId, 10) };

    case REMOVE_SELECTED_SCHEDULE_ID:
      return { ...state, selectedScheduleId: null };

    case SET_LAST_ACTIVE_VENUE_ID:
      return { ...state, lastActiveVenueId: venueId };

    default:
      return state;
  }
};
